import { useMemo } from 'react';
import { useFoodFeedback } from '../../../hooks/useFoodFeedback';

export function useFilteredFoodFeedbackItems() {
  const { data, isLoading } = useFoodFeedback({
    // The list of food feedbacks are stable. No need to fetch them
    // multiple times within the same session.
    options: {
      refetchOnMount: false,
      staleTime: Infinity,
    },
  });

  return useMemo(() => {
    if (isLoading || !data) {
      return {
        likedPairings: [],
        dislikedPairings: [],
        likedProducts: [],
        dislikedProducts: [],
      };
    }

    return {
      likedPairings: data.results.filter(
        ({ for_liked_pairings }) => for_liked_pairings
      ),
      dislikedPairings: data.results.filter(
        ({ for_disliked_pairings }) => for_disliked_pairings
      ),
      likedProducts: data.results.filter(
        ({ for_liked_products }) => for_liked_products
      ),
      dislikedProducts: data.results.filter(
        ({ for_disliked_products }) => for_disliked_products
      ),
    };
  }, [isLoading, data]);
}
